import React, { useState, useEffect, useMemo } from 'react';
import { Card, CardContent, FormControl, InputLabel, Select, MenuItem, Checkbox, FormControlLabel, Button, Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, CircularProgress } from '@mui/material';
import Grid from '@mui/material/Grid';
import axios from 'axios';
import { BASE_URL } from '../../App';
import Swal from 'sweetalert2';

const AssignExecutiveToDealer = () => {
  const [branchName, setBranchName] = useState('');
  const [executiveName, setExecutiveName] = useState('');
  const [dealerName, setDealerName] = useState([]);
  const [selectAllBranches, setSelectAllBranches] = useState(false);
  const [selectAllDealers, setSelectAllDealers] = useState(false);
  const [selectAllExecutives, setSelectAllExecutives] = useState(false);
  const [showTable, setShowTable] = useState(false);
  const [branches, setBranches] = useState([]);
  const [executives, setExecutives] = useState([]);
  const [dealers, setDealers] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [dealersToDelete, setDealersToDelete] = useState([]);
  const [isActive, setIsActive] = useState(false);
  const [groupcode, setgroupcode] = useState(null);

  const userGroupCode = localStorage.getItem("GROUP_CODE");
 
  const loginId = localStorage.getItem("LOGIN_ID");

  // useEffect(() => {
  //   if (!loginId || !userGroupCode) {
  //     Swal.fire('Error', 'Please log in to continue', 'error');

  //   }
  // }, [loginId, userGroupCode]);

  const fetchBranches = async () => {
    try {
      setLoading(true);
      const response = await axios.post(BASE_URL + '/fillBranch', {
        loginId: loginId,
        userGroupCode: userGroupCode,
      });
      setBranches(response.data.data || []);
      setgroupcode(response.data.userGroupCode);
    } catch (err) {
      setError('Failed to load branches');
    } finally {
      setLoading(false);
    }
  };


  const fetchExecutives = async (branchCode, cbAllChecked) => {
    try {
      setLoading(true);
      const response = await axios.post(BASE_URL + '/fillexecutiveName', {
        branchCode: branchCode,
        cbAllChecked: cbAllChecked,
      });
      setExecutives(response.data.data || []);
    } catch (err) {
      setError('Failed to load executives');
    } finally {
      setLoading(false);
    }
  };


  const fetchDealers = async (branchCode, cbAllChecked) => {
    try {

      setLoading(true);

      const response = await axios.post(BASE_URL + '/filldealername', {
        branchCode: branchCode === 'All Branches' ? '' : branchCode,
        cbAllChecked: cbAllChecked,
      });
      console.log(response.data);
      setDealers(response.data.data || []);
    } catch (err) {
      setError('Failed to load dealers');
    } finally {
      setLoading(false);
    }
  };


  const fetchGridData = async (branchCode, executiveId) => {
    Swal.showLoading();
    try {
      const response = await axios.post(BASE_URL + '/fillGrid', {
        executiveId: executiveId,
        branchCode: branchCode,
      });
      setTableData(response.data.data || []);
    } catch (err) {
      setError('Failed to fetch grid data');
    } finally {
      Swal.close();
    }
  };

  const handleSave = async () => {
    Swal.showLoading();
    try {
      const updatedDealers = dealerName.map((dealerCode) => ({
        DEALER_CODE: dealerCode,
        EXECUTIVE_USER_ID: executiveName,
        ACTIVE: isActive ? '1' : '0',
      }));

      const finalDealersToSave = [...updatedDealers];
      dealersToDelete.forEach((deletedDealerCode) => {
        finalDealersToSave.push({
          DEALER_CODE: deletedDealerCode,
          EXECUTIVE_USER_ID: executiveName,
          ACTIVE: '0',
        });
      });

      const response = await axios.post(BASE_URL + '/saveData', {
        executiveId: executiveName,
        dealers: dealerName,
        active: isActive,
        loginId: loginId,
      });

      Swal.fire('Success', 'Changes saved successfully', 'success');
      await fetchGridData(branchName, executiveName);
    } catch (err) {
      setError('Failed to save changes');
      Swal.fire('Error', 'Failed to save changes', 'error');
    } finally {
      Swal.close();
    }
  };

  const handleActiveChange = (dealerCode) => {
    setTableData((prevData) =>
      prevData.map((row) =>
        row.DEALER_CODE === dealerCode ? { ...row, ACTIVE: row.ACTIVE === '1' ? '0' : '1' } : row
      )
    );
  };

  const handleDeleteDealer = async (dealerCode) => {
    try {
      Swal.showLoading();
      const response = await axios.post(BASE_URL + '/deleteMapping', {
        executiveId: executiveName,
        dealerCode: dealerCode,
      });

      if (response.data.status_code === 200) {
        setTableData((prevData) => prevData.filter((row) => row.DEALER_CODE !== dealerCode));
        setDealersToDelete((prev) => [...prev, dealerCode]);
        Swal.fire('Success', 'Dealer deleted successfully', 'success');
      } else {
        Swal.fire('Error', 'Failed to delete dealer', 'error');
      }
    } catch (err) {
      Swal.fire('Error', 'An error occurred while deleting the dealer', 'error');
    } finally {
      Swal.close();
    }
  };

  useEffect(() => {
    fetchBranches();
  }, []);
  const handleBranchChange = (event) => {
    const branchCode = event.target.value;
    setBranchName(branchCode);

    if (branchCode === 'All Branches') {
      fetchExecutives('All Branches', true);
      fetchDealers('All Branches', true);
    } else {
      fetchExecutives(branchCode, selectAllExecutives);
      fetchDealers(branchCode, selectAllDealers);
    }
  };

  const handleExecutiveChange = (event) => {
    const selectedExecutiveId = event.target.value;
    console.log("Selected Executive:", selectedExecutiveId);
    setExecutiveName(selectedExecutiveId);

    if (branchName) {
      fetchGridData(branchName, selectedExecutiveId);
    }
  };

  const handleDealerChange = (event) => {
    const selectedDealers = event.target.value;
    setDealerName(selectedDealers);
  };

  const handleSelectAllChange = (event) => {
    if (event.target.checked) {
      setBranchName('All Branches');
    } else {

      setBranchName('');
    }
  };

  const handleSelectAllBranches = (event) => {
    const isChecked = event.target.checked;
    setSelectAllBranches(isChecked);

    if (isChecked) {
      setBranchName('All Branches');
      fetchExecutives('All Branches', true);
      fetchDealers('All Branches', true);
    } else {
      setBranchName('');
      setExecutives([]);
      setDealers([]);
    }
  };

  const handleSelectAllDealers = (event) => {
    const isChecked = event.target.checked;
    setSelectAllDealers(isChecked);

    setDealerName(isChecked ? dealers.map((dealer) => dealer.DEALER_CODE) : []);
  };

  const handleViewClick = async () => {
    setShowTable(true);
    await fetchGridData(branchName, executiveName);
  };
  const handleCancel = () => {
    setShowTable(false);
  };
  const executiveIds = useMemo(() => executives.map((exec) => exec.USER_ID), [executives]);
  return (

    <Card sx={{ width: '98%', display: 'flex', flexDirection: 'column', alignItems: 'flex-start', margin: 0, padding: 3 }}>
    <CardContent>
    <div className="column">
  <Grid container spacing={2} alignItems="center">
    <Grid item>
      <FormControl fullWidth>
        <InputLabel>Branch</InputLabel>
        <Select
          value={branchName}
          onChange={handleBranchChange}
          label="Branch"
          sx={{ width: 200 }}
        >
          {groupcode === '1' && (
            <MenuItem value="All Branches">All Branches</MenuItem>
          )}
          {branches.map((branch) => (
            <MenuItem key={branch.BRANCH_CODE} value={branch.BRANCH_CODE}>
              {branch.BRANCH_NAME}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Grid>

    {groupcode === '1' && (
    <Grid item>
      <FormControlLabel
        control={
          <Checkbox
            checked={selectAllBranches}
            onChange={handleSelectAllBranches}
            color="primary"
            disabled={groupcode !== '1'}
          />
        }
        label="Select All"
      />
    </Grid>
    )}

    <Grid item>
      <FormControl fullWidth>
        <InputLabel>Executive Name</InputLabel>
        <Select
          value={executiveName}
          onChange={handleExecutiveChange}
          label="Executive Name"
          sx={{ width: 200 }}
        >
          {executives.map((executive) => (
            <MenuItem key={executive.USER_ID} value={executive.USER_ID}>
              {executive.USER_NAME}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Grid>

    <Grid item>
      <FormControl fullWidth>
        <InputLabel>Dealer Name</InputLabel>
        <Select
          multiple
          value={dealerName}
          sx={{ width: 200 }}
          onChange={handleDealerChange}
          renderValue={(selected) => {
            const selectedDealers = dealers.filter((dealer) =>
              selected.includes(dealer.DEALER_CODE)
            );
            return selectedDealers.map((dealer) => dealer.DEALERNAME).join(', ');
          }}
        >
          {dealers.map((dealer) => (
            <MenuItem key={dealer.DEALER_CODE} value={dealer.DEALER_CODE}>
              <Checkbox checked={dealerName.includes(dealer.DEALER_CODE)} />
              {dealer.DEALERNAME}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Grid>

    <Grid item>
      <FormControlLabel
        control={
          <Checkbox
            checked={selectAllDealers}
            onChange={handleSelectAllDealers}
            color="primary"
          />
        }
        label="Select All"
      />
    </Grid>
  </Grid>

  <Grid container spacing={2}>
    <Grid item xs={12}>
      <Button
        variant="contained"
        color="primary"
        sx={{ marginTop: 2 }}
        onClick={handleViewClick}
        disabled={!branchName || !executiveName}
      >
        View
      </Button>
      {error && (
        <Typography color="error" variant="body2" sx={{ marginTop: 2 }}>
          {error}
        </Typography>
      )}
    </Grid>
  </Grid>
</div>



        {showTable && (
          <Box sx={{ marginTop: 3 }}>
            <TableContainer component={Paper} sx={{ maxHeight: '350px', overflow: 'auto' }}>
              <Table>
                <TableHead sx={{ backgroundColor: '#1976d2', color: 'white', position: 'sticky', top: 0, zIndex: 1 }}>
                  <TableRow>
                    <TableCell><strong>Branch Code</strong></TableCell>
                    <TableCell><strong>Executive Name</strong></TableCell>
                    <TableCell><strong>Dealer Code</strong></TableCell>
                    <TableCell><strong>Active</strong></TableCell>
                    <TableCell><strong>Delete</strong></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {tableData.map((row, index) => {
                    const executive = executives.find((exec) => exec.USER_ID === row.EXECUTIVE_USER_ID);
                    const executiveName = executive ? executive.USER_NAME : 'N/A';
                    return (
                      <TableRow key={index}>
                        <TableCell>{row.BRANCH_CODE}</TableCell>
                        <TableCell>{executiveName}</TableCell>
                        <TableCell>{row.DEALER_CODE}</TableCell>
                        <TableCell style={{ color: row.ACTIVE === '1' ? 'green' : 'red' }}>
                          {row.ACTIVE === '1' ? 'True' : 'False'}
                        </TableCell>
                        <TableCell>
                          <Button variant="contained" color="warning" onClick={() => handleDeleteDealer(row.DEALER_CODE)}>
                            Delete
                          </Button>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
            <Box sx={{ marginTop: 2, display: 'flex', justifyContent: 'space-between' }}>
              <FormControlLabel
                control={<Checkbox checked={isActive} onChange={(e) => setIsActive(e.target.checked)} />}
                label="Active"
              />
              <Box>
                <Button variant="contained" color="primary" onClick={handleSave}>
                  Save
                </Button>
                <Button variant="outlined" color="secondary" onClick={handleCancel}>
                  Cancel
                </Button>
              </Box>
            </Box>
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

export default AssignExecutiveToDealer;

